import { ENUM_MortgagePartStepType } from '@api-new/common';
import { SelectItem } from 'primeng/api';

export const mortgageInterestRateSelectItems: SelectItem<ENUM_MortgagePartStepType>[] = [
  {
    label: 'Fixed',
    value: ENUM_MortgagePartStepType.MORTGAGE_PART_STEP_TYPE_FIXED,
  },
  {
    label: 'Variable',
    value: ENUM_MortgagePartStepType.MORTGAGE_PART_STEP_TYPE_VARIABLE,
  },
];
